module.exports = __webpack_public_path__ + "static/img/setingu5.0dd27a48.png";